import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m7 14-1.147 4.59c-.32 1.281 1.052 2.321 2.2 1.666L12 18l3.948 2.256c1.147.655 2.52-.385 2.2-1.666L17 14l3.346-2.788c1.008-.84.527-2.478-.775-2.64L15.001 8l-1.622-3.783c-.52-1.212-2.238-1.212-2.758 0L9.001 8l-4.572.571c-1.302.163-1.782 1.801-.774 2.641z"
    }
  )
);
var SvgStarFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var StarFilled_default = SvgStarFilled;

export { StarFilled_default as default };
